import { Fade } from "react-awesome-reveal";
import { motion } from 'framer-motion';
import { useScrollVariables } from '../scrollVariables';

export default function Video() {

        const {
                labelContainerRef,
                projectTextRef,
                labelOpacity,
        } = useScrollVariables();

        return (
                <div className="video" id="video">
                        <div className="label-container" ref={labelContainerRef}>
                                <motion.div style={{ opacity: labelOpacity }}>
                                        05 VIDEO
                                </motion.div>
                        </div>
                        <div className="d-flex justify-content-center">
                                <motion.p className="project-text" ref={projectTextRef}>Cinematography and video editing has catapulted my work into new heights, allowing me to discover a new medium that combines all of my interests. It has become my primary mode of expression, and is an endless journey of creativity.</motion.p>
                        </div>
                        <div className="d-flex justify-content-center">
                                <motion.p className="project-text-2" ref={projectTextRef}>Click or tap below to watch.</motion.p>
                        </div>
                        <div className="container work-container">
                                <div className="row align-items-center justify-content-center" id="gallery">
                                        <div className="col-12 col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center">
                                                <Fade duration={500}>
                                                        <a href="https://www.youtube.com/watch?v=VKvQraXvfgY&t=1s" target="_blank" rel="noopener noreferrer">
                                                        <img src="img/youtube-work/youve-been-lied-to-about-morning-routines.JPG" className="youtube-work" alt="youtube-work-1" />
                                                        </a>
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center">
                                                <Fade duration={500}>
                                                        <a href="https://www.youtube.com/watch?v=ieYGFZA78SI" target="_blank" rel="noopener noreferrer">
                                                        <img src="img/youtube-work/a-list-of-things-to-do-when-youre-bored.JPG" className="youtube-work" alt="youtube-work-2" />
                                                        </a>
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center">
                                                <Fade duration={500}>
                                                        <a href="https://www.youtube.com/watch?v=ugODqzjCIdo&t=108s" target="_blank" rel="noopener noreferrer">
                                                        <img src="img/youtube-work/each-stage-of-life-is-a-new-start.jpg" className="youtube-work" alt="youtube-work-3" />
                                                        </a>
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center">
                                                <Fade duration={500}>
                                                        <a href="https://www.youtube.com/watch?v=5tfyRqBcMWQ" target="_blank" rel="noopener noreferrer">
                                                        <img src="img/youtube-work/i-found-happiness-in-this-moment.jpg" className="youtube-work" alt="youtube-work-5" />
                                                        </a>
                                                </Fade>
                                        </div>
                                </div>
                        </div>
                </div>
        )
}